"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setUserRoomsCountFlag = exports.setUserAreaFlag = exports.setRooms = exports.setNewbuildingId = exports.setLandArea = exports.setJkRooms = exports.setHouseId = exports.setHouseArea = exports.setFlatNumber = exports.setEstimationTarget = exports.setError = exports.setArea = exports.setAddress = exports.resetFilters = void 0;
var _actionGenerator = require("../../utils/actionGenerator");
var _types = require("./types");
const {
  SET_ESTIMATION_TARGET,
  SET_USER_AREA_FLAG,
  SET_USER_ROOMS_COUNT_FLAG,
  SET_ERROR,
  SET_ROOMS,
  SET_JK_ROOMS,
  SET_AREA,
  SET_ADDRESS,
  SET_NEWBUILDING_ID,
  SET_HOUSE_ID,
  RESET_FILTERS,
  SET_HOUSE_AREA,
  SET_LAND_AREA,
  SET_FLAT_NUMBER
} = _types.EActionTypes;
const setAddress = exports.setAddress = (0, _actionGenerator.actionGenerator)(SET_ADDRESS);
const setRooms = exports.setRooms = (0, _actionGenerator.actionGenerator)(SET_ROOMS);
const setJkRooms = exports.setJkRooms = (0, _actionGenerator.actionGenerator)(SET_JK_ROOMS);
const setUserRoomsCountFlag = exports.setUserRoomsCountFlag = (0, _actionGenerator.actionGenerator)(SET_USER_ROOMS_COUNT_FLAG);
const setUserAreaFlag = exports.setUserAreaFlag = (0, _actionGenerator.actionGenerator)(SET_USER_AREA_FLAG);
const setArea = exports.setArea = (0, _actionGenerator.actionGenerator)(SET_AREA);
const setFlatNumber = exports.setFlatNumber = (0, _actionGenerator.actionGenerator)(SET_FLAT_NUMBER);
const setError = exports.setError = (0, _actionGenerator.actionGenerator)(SET_ERROR);
const resetFilters = exports.resetFilters = (0, _actionGenerator.actionGenerator)(RESET_FILTERS);
const setEstimationTarget = exports.setEstimationTarget = (0, _actionGenerator.actionGenerator)(SET_ESTIMATION_TARGET);
const setNewbuildingId = exports.setNewbuildingId = (0, _actionGenerator.actionGenerator)(SET_NEWBUILDING_ID);
const setHouseId = exports.setHouseId = (0, _actionGenerator.actionGenerator)(SET_HOUSE_ID);
const setLandArea = exports.setLandArea = (0, _actionGenerator.actionGenerator)(SET_LAND_AREA);
const setHouseArea = exports.setHouseArea = (0, _actionGenerator.actionGenerator)(SET_HOUSE_AREA);